import { API } from "../auth/authApi";

API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");
  if (token) req.headers.Authorization = `Bearer ${token}`;
  return req;
});

export const getSponsorsApi = (params) => {
  return API.get("/sponser/users", { params });
};

export const getSponsorDetailsApi = (id) => {
  return API.get("/user/info/", {
    params: { id },
  });
};

export const createSponsorApi = (data) => {
  return API.post("/sponser/add-user", data, {
    skipGlobalErrorHandler: true,
  });
};

export const assignStaffToSponsorApi = (data) => {
  return API.post("/sponser/assign-staff", data);
};

export const assignSponsorLocationApi = (data) => {
  return API.post("/sponser/assign-location", data);
};

export const removeSponsorLocationApi = (data) => {
  return API.delete("/sponser/remove-location", { data });
};

export const getSponsorQuotaApi = (sponsorId) => {
  return API.get(`/sponser/quota/${sponsorId}`);
};
